import React from 'react';
import Icon from 'Components/Icon';
import PropTypes from 'prop-types';
import { classnames } from 'Utils/classnames';
import { oddFormatter } from 'Utils/decimalFormatter';
import { horseMessage } from 'Utils/decimalFormatter';

const BetSlipHorse = ({ horse, onHorseDelete }) => {
  if (!horse) {
    return null;
  }

  const horseNoClass = classnames({
    'horse-row__horse-no': true,
    [`horse-row__horse-no__ekuri${horse.stablemateGroupInfo}`]: horse.stablemateGroupInfo
  });

  const message = horseMessage(horse?.propositionInfo?.status);


  return (
    <div className="horse-row">
      <div className={ horseNoClass }>{ horse.horseNo }</div>
      <div className="horse-row__separator"/>
      <div
        className="horse-row__horse-name">{ horse.name } { horse?.propositionInfo?.odd ? `(Oran: ${oddFormatter(horse?.propositionInfo)})` : '' }</div>
      { onHorseDelete && <Icon className="horse-row__trash" iconName="svgTrash" onClick={ () => {
        onHorseDelete(horse);
      } }/> }
      {
        !horse.isRunning
          ? <div className='horse-row__not-run'>
            <div>Koşmaz</div>
          </div> : null
      }
      {
        message && <div className="horse-row__message">
          <div className="text">{ message }</div>
          <div className="messageDelete">
            <Icon iconName="svgTrashRed" onClick={ () => {
              onHorseDelete(horse);
            } }/>
          </div>
        </div>
      }
    </div>
  );
};
BetSlipHorse.propTypes = {
  horse: PropTypes.object,
  onHorseDelete: PropTypes.func
};


export default BetSlipHorse;
